import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforoutstationpune() {



const cardData =
{
  keyword: 'Bus Hire for Outstation Pune',
  heading: 'Sanavi Travels: Bus Hire for Outstation Pune',
  headingDescription: 'Sanavi Travels offers reliable and comfortable bus hire for outstation travel from Pune, suitable for family trips, corporate tours, weddings, picnics, and long-distance journeys. With AC and Non-AC buses, skilled drivers, flexible routes, and transparent pricing, we ensure safe and smooth outstation travel from Pune to popular destinations.',

  top: 'Popular Outstation Travel Purposes from Pune with Sanavi Travels',

  "topPlaces": [
    {
      "title": "Family Outstation Trips from Pune",
      "description": "Family outstation trips from Pune are best managed with dedicated bus rentals that keep everyone together throughout the journey. Buses provide enough space for passengers and luggage, making travel comfortable for elders and children alike. Whether it is a weekend getaway or a multi-day vacation, group bus travel ensures better coordination, reduced fatigue, and a relaxed travel atmosphere."
    },
    {
      "title": "Corporate Outstation Tours",
      "description": "Corporate outstation travel requires punctuality, planning, and professional service. Hiring a bus for corporate outstation trips from Pune allows teams to travel together, maintain schedules, and avoid logistical challenges. These services are ideal for off-sites, conferences, training programs, and team-building tours."
    },
    {
      "title": "Wedding & Function Outstation Travel",
      "description": "Outstation weddings and ceremonies often involve transporting guests between cities or towns. Bus hire for wedding outstation travel ensures timely movement of guests, reduces coordination stress, and adds convenience for hosts managing large groups."
    },
    {
      "title": "Picnic & Leisure Outstation Travel",
      "description": "Picnic and leisure trips from Pune to nearby hill stations, beaches, or resorts are more enjoyable when everyone travels together. Bus rentals offer a relaxed environment, social interaction during travel, and safe transport to leisure destinations."
    },
    {
      "title": "Religious & Pilgrimage Tours",
      "description": "Religious outstation journeys from Pune to temples and pilgrimage centers are commonly organized in groups. Buses allow devotees to travel together comfortably, ensuring timely darshan and reduced travel fatigue."
    },
    {
      "title": "Educational & Student Tours",
      "description": "Schools and colleges frequently organize outstation tours and excursions. Bus hire ensures student safety, disciplined travel, and easy supervision during long-distance journeys."
    },
    {
      "title": "Tour Packages & Sightseeing Routes",
      "description": "Tour operators and groups traveling on fixed sightseeing routes benefit from outstation bus rentals that support planned itineraries, multiple stops, and comfortable long-distance travel."
    },
    {
      "title": "Long-Distance Group Travel",
      "description": "For long-distance group travel from Pune, buses provide stability, comfort, and cost-effective transportation, making them ideal for extended journeys."
    }
  ],

  "services": [
    {
      "name": "Bus Hire for Outstation Pune",
      "description": "Sanavi Travels provides comprehensive bus hire services for outstation travel from Pune, catering to families, corporate teams, wedding groups, and tour operators. This service focuses on safe long-distance travel, comfortable seating, proper luggage space, and experienced drivers familiar with highways and regional routes. It is ideal for both short outstation trips and extended multi-day journeys."
    },
    {
      "name": "AC Bus for Outstation Pune",
      "description": "AC buses ensure a comfortable and pleasant travel environment for long-distance journeys, especially during hot weather. These buses help passengers remain relaxed and refreshed throughout the trip."
    },
    {
      "name": "Non AC Bus Hire Pune Outstation",
      "description": "Non-AC buses offer a budget-friendly option for outstation travel, suitable for groups looking for reliable transportation without premium features."
    },
    {
      "name": "Luxury Bus Hire for Outstation Pune",
      "description": "Luxury buses provide enhanced comfort, premium interiors, and smooth ride quality, making them ideal for weddings, VIP travel, and corporate outstation tours."
    },
    {
      "name": "Mini Bus on Rent for Outstation Pune",
      "description": "Mini buses are suitable for small to medium-sized groups, offering flexibility, comfort, and efficient travel for short and medium-distance outstation trips."
    },
    {
      "name": "32 Seater Bus for Outstation Pune",
      "description": "32 seater buses are ideal for medium-sized groups, balancing seating capacity, luggage space, and comfort for outstation journeys."
    },
    {
      "name": "35 Seater Bus Hire Pune Outstation",
      "description": "35 seater buses support large group travel, ensuring everyone travels together comfortably for long-distance trips."
    },
    {
      "name": "Bus Hire for Family Outstation Pune",
      "description": "Family outstation bus services ensure coordinated travel, safety, and convenience for all age groups during long journeys."
    },
    {
      "name": "Bus Hire for Corporate Outstation Pune",
      "description": "Corporate outstation buses support professional travel needs for off-sites, meetings, and training programs with punctual and organized transport."
    },
    {
      "name": "Affordable Outstation Bus Rental Pune",
      "description": "Affordable packages provide cost-effective outstation travel solutions without compromising on safety or reliability."
    },
    {
      "name": "Best Outstation Bus Service Pune",
      "description": "Sanavi Travels is recognized for providing dependable and well-managed outstation bus services from Pune."
    },
    {
      "name": "Bus Hire with Driver for Outstation Pune",
      "description": "All outstation bus rentals include experienced drivers skilled in highway and long-distance travel, ensuring passenger safety."
    },
    {
      "name": "Bus for Wedding Outstation Pune",
      "description": "Wedding outstation buses ensure organized guest transportation between cities, hotels, and event venues."
    },
    {
      "name": "Bus for Picnic Outstation Pune",
      "description": "Picnic outstation buses support relaxed group travel to leisure destinations around Maharashtra."
    },
    {
      "name": "Bus for Tour Packages Outstation Pune",
      "description": "Tour package buses support structured itineraries, multiple destinations, and comfortable long-distance travel."
    }
  ],

  "tableData": [
    ["Outstation Bus", "AC Bus"],
    ["Non AC Bus", "Luxury Bus"],
    ["Mini Bus", "32 Seater Bus"],
    ["35 Seater Bus", "Wedding Travel"],
    ["Corporate Travel", "Tour Packages"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable Long-Distance Travel", "WhyChoosedescription": "Designed for relaxed and safe outstation journeys." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Drivers trained for highways and long-distance routes." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "AC, Non-AC, luxury, mini, 32 and 35 seater buses available." },
    { "WhyChooseheading": "Well-Maintained Fleet", "WhyChoosedescription": "Regularly serviced and clean buses." },
    { "WhyChooseheading": "Flexible Routes", "WhyChoosedescription": "Customizable travel routes and destinations." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Suitable for All Groups", "WhyChoosedescription": "Families, corporates, weddings, and tours." },
    { "WhyChooseheading": "Trusted Service Provider", "WhyChoosedescription": "Sanavi Travels is a reliable outstation travel partner." }
  ]
};

const faqData = [
  { question: 'Do you provide outstation bus hire from Pune?', answer: 'Yes, Sanavi Travels offers bus hire services for outstation travel from Pune.' },
  { question: 'Are AC buses available for outstation trips?', answer: 'Yes, AC and Non-AC buses are available for outstation travel.' },
  { question: 'What bus sizes are available?', answer: 'Mini buses, 32 seater, and 35 seater buses are available.' },
  { question: 'Is a driver included with the bus?', answer: 'Yes, all rentals include experienced drivers.' },
  { question: 'Can buses be hired for multi-day outstation trips?', answer: 'Yes, buses can be hired for single-day or multi-day trips.' },
  { question: 'Do you offer buses for weddings and corporate travel?', answer: 'Yes, outstation buses are available for weddings and corporate events.' },
  { question: 'Are buses cleaned before travel?', answer: 'Yes, buses are cleaned and maintained regularly.' },
  { question: 'Can routes be customized?', answer: 'Yes, routes and destinations can be customized.' },
  { question: 'Is outstation bus travel cost-effective?', answer: 'Yes, group bus travel reduces overall travel costs.' },
  { question: 'How can I book an outstation bus from Pune?', answer: 'You can book online or contact our customer support team.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'Very smooth outstation bus journey from Pune. Comfortable and reliable service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'We hired a bus for our family outstation trip. Excellent coordination and service.',
    rating: 5
  }
];








































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Outstation Pune - Sanavi Travels",
  "description": "Sanavi Travels offers buses for outstation trips from Pune for family travel, corporate trips, weddings, picnics, and tour packages. AC and Non-AC buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for Outstation Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for outstation trips from Pune with Sanavi Travels. AC & Non-AC mini buses, 32-seater and 35-seater buses for family travel, corporate trips, weddings, picnics, and tour packages with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/273.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforoutstationpune;